import { render, staticRenderFns } from "./SecurityTab.vue?vue&type=template&id=46039a06&scoped=true"
import script from "./SecurityTab.vue?vue&type=script&setup=true&lang=ts"
export * from "./SecurityTab.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SecurityTab.vue?vue&type=style&index=0&id=46039a06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46039a06",
  null
  
)

export default component.exports